import React, { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import BigCLoading from "../components/Loading";

const LineLiffRedirect = () => {

  useEffect(async () => {
    async function fetchData() {
      const searchParam = window.location.search;
      if (isMobile) {
        window.location.href = `line://app/${process.env.REACT_APP_LINE_CONNECT_LIFF_ID}/${searchParam}`;
      } else {
        window.location.href = `https://liff.line.me/${process.env.REACT_APP_LINE_CONNECT_LIFF_ID}/${searchParam}`;
      }
    }
    fetchData();
  }, []);
  return <></>;
};

export default LineLiffRedirect;
